import React from "react";
import section2img from "../assests/HomeImg/section2-img.svg";
import "./index.css";

// Import PDFs manually from assets
import report1 from "../assests/composite_schema/Report-On-Distribution-Of-Sale-Proceeds-Of-Fractional-Shares.pdf";
import report2 from "../assests/composite_schema/Outcome-BM-Dec-16-2025.pdf";
import report3 from "../assests/composite_schema/Effective-Date-1-Disclosure.pdf";
import report4 from "../assests/composite_schema/Outcome-Name-change-and-object.pdf";
import report5 from "../assests/composite_schema/Record-date-2-Disclosure.pdf";
import report6 from "../assests/composite_schema/Intimation-of-Record-date1.pdf";
import report7 from "../assests/composite_schema/CO.pdf";
import report8 from "../assests/composite_schema/SSL-Reg-30-NCLT-Website-order-sigend.pdf";
import report9 from "../assests/composite_schema/SEsigned-1.pdf";
import report10 from "../assests/composite_schema/Newspaper-intimation.pdf";
import report11 from "../assests/composite_schema/NCLT-Proceedings-Equity-Shareholders.pdf";
import report12 from "../assests/composite_schema/Evoting-NCLT-XBRL.pdf";
import report13 from "../assests/composite_schema/NCLT-Proceedings-Unsecured-Trade-Creditors.pdf";
import report14 from "../assests/composite_schema/Scrutinizer-Report-Unsecured-Trade-Creditors.pdf";
import report15 from "../assests/composite_schema/Scritinizer-Report-Equity-Shareholders.pdf";
import report16 from "../assests/composite_schema/newspaper.pdf";
import report17 from "../assests/composite_schema/SE-Intimation-NCLT-Notice-to-Shareholders-and-Creditors.pdf";
// Note: Annexures R7 and R6 (IDs 18, 19) were not found in the assets folder
import report20 from "../assests/composite_schema/NCLT-SRL-Notice-of-Unsecured-Trade-Creditors-1-1.pdf";
import report21 from "../assests/composite_schema/NCLT-SSL-Notice-of-Unsecured-Trade-Creditors.pdf";
import report22 from "../assests/composite_schema/NCLT-SSL-Notice-of-Equity-shareholders.pdf";
import report23 from "../assests/composite_schema/Abridged-Prospectus-Annexure14A-to-I-final-website.pdf";
import report24 from "../assests/composite_schema/SSL-SEBI-Approval-signedv1.pdf";
import report25 from "../assests/composite_schema/Scheme-of-arrangement-CCI-Approval.pdf";
import report26 from "../assests/composite_schema/Scheme-of-Arrangement-1.pdf";
import report27 from "../assests/composite_schema/NSE-Complaint-Report-Final.pdf";
import report28 from "../assests/composite_schema/BSE-Complaint-Report-Finalupload.pdf";
import report29 from "../assests/composite_schema/No-material-event-impacting-the-valuation-has-occurred-during-the-intervening-period-of-filing-the-scheme-documents-with-Stock-Exchange.pdf";
import report30 from "../assests/composite_schema/Declaration-from-the-listed-entity-on-any-past-defaults-of-listed-debt-obligations-of-the-entities-forming-part-of-the-scheme.pdf";
import report31 from "../assests/composite_schema/14.-No-Objection-certificate-from-lenders-with-respect-to-composite-scheme-of-amalgamation.pdf";
import report32 from "../assests/composite_schema/13.-Board-Resolution.pdf";
import report33 from "../assests/composite_schema/12.-Compliance-Report.pdf";
import report34 from "../assests/composite_schema/11.-Independent-Director-Report.pdf";
import report35 from "../assests/composite_schema/10.-Post-shareholding.pdf";
import report36 from "../assests/composite_schema/9.-Pre-Shareholding.pdf";
import report37 from "../assests/composite_schema/8.-Share-Entitlement-Ratio.pdf";
import report38 from "../assests/composite_schema/6.-Audit-Committee-Report.pdf";
import report39 from "../assests/composite_schema/4.-Fairness-Opinion.pdf";
import report40 from "../assests/composite_schema/3.-Statutory-Auditors-Certificate.pdf";
import report41 from "../assests/composite_schema/2.-Latest-Audited-Finacials.pdf";
import report42 from "../assests/composite_schema/Updated-scheme-on-website.pdf";
import report43 from "../assests/composite_schema/Investor-Presentation-September-27-2024.pdf";
import report44 from "../assests/composite_schema/OutcomeBM26092024FINALFinalsigned-1.pdf";
import report45 from "../assests/composite_schema/SequentScientificLtd-Oct01-2024.pdf";
import report46 from "../assests/composite_schema/COA_Document_Sequent.pdf";
import report47 from "../assests/composite_schema/BSENSEpublicationIntimation.pdf";
import report48 from "../assests/composite_schema/Sequent_presentation.pdf";
import report49 from "../assests/composite_schema/Sequent Scientific Shareholders Notice.pdf";
import report50 from "../assests/composite_schema/Sequent Scientific Postal Ballot Form.pdf";
import report51 from "../assests/composite_schema/Evoting Instructions.pdf";
import report52 from "../assests/composite_schema/Observation_Letter_NSE.pdf";
import report53 from "../assests/composite_schema/Observation_Letter_BSE.pdf";
import report54 from "../assests/composite_schema/Revised_Valuation_Report.pdf";
import report55 from "../assests/composite_schema/Final_Scheme_of_Demerger.pdf";
import report56 from "../assests/composite_schema/Board Resolution.pdf";
import report57 from "../assests/composite_schema/Fairness Opinion.pdf";
import report58 from "../assests/composite_schema/Audit Committee Report.pdf";
import report59 from "../assests/composite_schema/Valuation Certificate.pdf";
import report60 from "../assests/composite_schema/Accounting Treatment Certificate.pdf";
import report61 from "../assests/composite_schema/Networth Certificate.pdf";
import report62 from "../assests/composite_schema/Compliance Report.pdf";
import report63 from "../assests/composite_schema/Corporate Governance Report.pdf";
import report64 from "../assests/composite_schema/Rationale.pdf";
import report65 from "../assests/composite_schema/Brief Details of Companies.pdf";


const schemeData = [
    { id: 1, title: "Report On Distribution Of Sale Proceeds Of Fractional Shares", year: 2026, role: report1 },
    { id: 2, title: "Effectiveness of scheme", year: 2025, role: report2 },
    { id: 3, title: "Effective date 1", year: 2025, role: report3 },
    { id: 4, title: "Amendments to MOA and AOA", year: 2025, role: report4 },
    { id: 5, title: "Intimation of Record date 2", year: 2025, role: report5 },
    { id: 6, title: "Intimation of Record date1", year: 2025, role: report6 },
    { id: 7, title: "Certified order passed by NCLT, Hyderabad Bench", year: 2025, role: report7 },
    { id: 8, title: "Written order of NCLT, Hyderabad Bench", year: 2025, role: report8 },
    { id: 9, title: "Pronouncement by Hon’ble NCLT, Hyderabad Bench approving Composite Scheme of amalgamation", year: 2025, role: report9 },
    { id: 10, title: "Newspaper Publication: Notice of Petition", year: 2025, role: report10 },
    { id: 11, title: "Proceedings for NCLT Convened Meeting- Equity Shareholders", year: 2025, role: report11 },
    { id: 12, title: "NCLT Convened Meeting Evoting Results", year: 2025, role: report12 },
    { id: 13, title: "Proceedings for NCLT Convened Meeting- Unsecured Trade Creditors", year: 2025, role: report13 },
    { id: 14, title: "Scrutinizer’s Report NCLT Convened Meeting- Unsecured Trade Creditors", year: 2025, role: report14 },
    { id: 15, title: "Scrutinizer’s Report NCLT Convened Meeting- Shareholders", year: 2025, role: report15 },
    { id: 16, title: "Newspaper Publication – NCLT Notice", year: 2025, role: report16 },
    { id: 17, title: "SE Intimation-NCLT Notice to Shareholders and Creditors", year: 2025, role: report17 },
    { id: 18, title: "NCLT-SSL-Notice of Unsecured Trade Creditors and Shareholders – Annexures", year: 2025, role: "https://sequent.in/wp-content/uploads/2025/09/2_292996_Sequent-Scientific_Annexures_R7.pdf" },
    { id: 19, title: "NCLT-SRL-Notice of Unsecured Trade Creditors- Annexures", year: 2025, role: "https://sequent.in/wp-content/uploads/2025/07/2_292996_Sequent-Scientific_Annexures_R6.pdf" },
    { id: 20, title: "NCLT-SRL-Notice of Unsecured Trade Creditors", year: 2025, role: report20 },
    { id: 21, title: "NCLT-SSL-Notice of Unsecured Trade Creditors", year: 2025, role: report21 },
    { id: 22, title: "NCLT-SSL-Notice of Equity shareholders", year: 2025, role: report22 },
    { id: 23, title: "Abridged Prospectus-SRL", year: 2025, role: report23 },
    { id: 24, title: "NOC from BSE NSE", year: 2025, role: report24 },
    { id: 25, title: "Scheme-of-arrangement-CCI-Approval", year: 2025, role: report25 },
    { id: 26, title: "Scheme of Arrangement", year: 2025, role: report26 },

    // 2024 Documents (20 entries)
    { id: 27, title: "Complaint Report-NSE", year: 2024, role: report27 },
    { id: 28, title: "Compliant Report-BSE", year: 2024, role: report28 },
    { id: 29, title: "No material event impacting the valuation has occurred during the intervening period of filing the scheme documents with Stock Exchange", year: 2024, role: report29 },
    { id: 30, title: "Declaration from the listed entity on any past defaults of listed debt obligations of the entities forming part of the scheme", year: 2024, role: report30 },
    { id: 31, title: "No Objection certificate from lenders with respect to composite scheme of amalgamation", year: 2024, role: report31 },
    { id: 32, title: "Board Resolution", year: 2024, role: report32 },
    { id: 33, title: "Compliance Report", year: 2024, role: report33 },
    { id: 34, title: "Independent Director Report", year: 2024, role: report34 },
    { id: 35, title: "Post-shareholding of Sequent Scientific Limited", year: 2024, role: report35 },
    { id: 36, title: "Pre-shareholding of all entities which are part of the Scheme", year: 2024, role: report36 },
    { id: 37, title: "Joint Valuation Report", year: 2024, role: report37 },
    { id: 38, title: "Audit Committee Report", year: 2024, role: report38 },
    { id: 39, title: "Fairness Opinion", year: 2024, role: report39 },
    { id: 40, title: "Statutory Auditor Certificate on Accounting Treatment", year: 2024, role: report40 },
    { id: 41, title: "Latest Audited Financials", year: 2024, role: report41 },
    { id: 42, title: "Composite Scheme Amalgamation", year: 2024, role: report42 },
    { id: 43, title: "Merger Proposal Investor Presentation – September 27, 2024", year: 2024, role: report43 },
    { id: 44, title: "Outcome of Board meeting- September 26, 2024", year: 2024, role: report44 },
    { id: 45, title: "Transcript of Merger Conference Call – October 01, 2024", year: 2024, role: report45 },

    // 2017 Documents (18 entries, 1 with no URL)
    { id: 46, title: "Cost of Acquisition Document", year: 2017, role: report46 },
    { id: 47, title: "BSE and NSE Publication Intimation", year: 2017, role: report47 },
    { id: 48, title: "Investor Presentation", year: 2017, role: report48 },
    { id: 49, title: "Notice of NCLT convened Meeting", year: 2017, role: report49 },
    { id: 50, title: "Postal Ballot Form", year: 2017, role: report50 },
    { id: 51, title: "E-voting Instructions", year: 2017, role: report51 },
    { id: 52, title: "Observation Letter NSE", year: 2017, role: report52 },
    { id: 53, title: "Observation Letter BSE", year: 2017, role: report53 },
    { id: 54, title: "Revised Valuation Report", year: 2017, role: report54 },
    { id: 55, title: "Scheme of Demerger", year: 2017, role: report55 },
    { id: 56, title: "Board Resolution", year: 2017, role: report56 },
    { id: 57, title: "Fairness Opinion", year: 2017, role: report57 },
    { id: 58, title: "Audit Committee Report", year: 2017, role: report58 },
    { id: 59, title: "Valuation Certificate", year: 2017, role: report59 },
    { id: 60, title: "Auditors Certificate on Accounting Treatment", year: 2017, role: report60 },
    { id: 61, title: "Networth Certificate", year: 2017, role: report61 },
    { id: 62, title: "Compliance Report", year: 2017, role: report62 },
    { id: 63, title: "Corporate Governance Report", year: 2017, role: report63 },
    { id: 64, title: "Rationale", year: 2017, role: report64 },
    { id: 65, title: "Brief Details of companies", year: 2017, role: report65 },
];

const PdfIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#E53935" opacity="0.15" />
        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="M14 2V8H20" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 13H15M9 17H13" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const DownloadIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 15V19C21 19.5304 20.7893 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CompositeScheme = () => {
    return (
        <div className="scheme-page">
            {/* HERO */}
            <section className="fin-hero">
                <div className="fin-hero-content">
                    <h1>Composite Scheme of Arrangement</h1>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p>Access official documents, NCLT orders, and disclosures related to the company's composite scheme of arrangement.</p>
                </div>
            </section>

            {/* CONTENT */}
            <section className="fin-content">
                <div className="fin-content-inner">
                    <div className="fin-filter-bar">
                        <div className="fin-filter-left">
                            <h2 className="fin-section-title">Scheme Documents</h2>
                            <span className="fin-result-count">{schemeData.length} Files</span>
                        </div>
                    </div>

                    <div className="fin-reports-grid">
                        {schemeData.map((item, index) => (
                            <div 
                                key={index} 
                                className="fin-report-card"
                                onClick={() => window.open(item.role, "_blank")}
                            >
                                <div className="fin-card-top">
                                    <div className="fin-card-icon-wrapper">
                                        <PdfIcon />
                                    </div>
                                </div>
                                <div className="fin-card-body">
                                    <h4 className="fin-card-title">{item.title}</h4>
                                </div>
                                <div className="fin-card-footer">
                                    <span className="fin-card-period">{item.year}</span>
                                    <button
                                        className="fin-download-btn"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            window.open(item.role, "_blank");
                                        }}
                                        title="Download PDF"
                                    >
                                        <DownloadIcon />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CompositeScheme;
